const REMINDER_TIMELINE_EVENT_TYPES = new Set([
  'confirmation_reminder_sent',
  'interview_reminder_sent',
]);

export function isReminderTimelineEvent(event) {
  return REMINDER_TIMELINE_EVENT_TYPES.has(
    String(event?.event_type || '').trim().toLowerCase()
  );
}

export function getReminderEventLabel(event) {
  const eventType = String(event?.event_type || '').trim().toLowerCase();
  const storedTitle = String(event?.title || '').trim();
  if (eventType === 'confirmation_reminder_sent') {
    const participant = String(event?.event_data?.participant || '')
      .trim()
      .toLowerCase();
    if (participant === 'interviewer') {
      return 'Interviewer confirmation reminder sent';
    }
    if (participant === 'candidate') {
      return 'Candidate confirmation reminder sent';
    }
    if (storedTitle) return storedTitle;
    return 'Confirmation reminder sent';
  }
  if (eventType === 'interview_reminder_sent') {
    return storedTitle || 'Interview reminder sent';
  }
  return storedTitle || 'Reminder sent';
}

export function getReminderStatusLabel(event) {
  const sentFlag = event?.event_data?.sent;
  if (sentFlag === false) return 'Reminder failed';
  return 'Reminder sent';
}

function uniqueEmailList(values = []) {
  const seen = new Set();
  const emails = [];
  values.forEach((value) => {
    const email = String(value || '').trim();
    if (!email) return;
    const key = email.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    emails.push(email);
  });
  return emails;
}

export function resolveReminderRecipientEmails(event, booking) {
  const data = event?.event_data || {};
  const collected = [];
  collected.push(data.recipient_email);
  if (Array.isArray(data.sent)) {
    data.sent.forEach((item) => {
      if (typeof item === 'string') {
        collected.push(item);
        return;
      }
      collected.push(item?.recipient_email);
    });
  }
  const fromEvent = uniqueEmailList(collected);
  if (fromEvent.length) return fromEvent;

  const participant = String(data.participant || '').trim().toLowerCase();
  const eventBookingId = String(event?.booking_id || '').trim();
  const currentBookingId = String(booking?.booking_id || '').trim();
  const bookingMatches =
    !eventBookingId || !currentBookingId || eventBookingId === currentBookingId;
  if (!bookingMatches) return [];
  if (participant === 'candidate') {
    return uniqueEmailList([booking?.candidate_email]);
  }
  if (participant === 'interviewer') {
    return uniqueEmailList([booking?.interviewer_email]);
  }
  return [];
}

export function resolveReminderSenderEmail(event) {
  return String(event?.actor_email || '').trim();
}
